import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-redirect-old-routes',
  templateUrl: './redirect-old-routes.component.html',
  styleUrl: './redirect-old-routes.component.scss',
})
export class RedirectOldRoutesComponent {
  constructor(private router: Router, private route: ActivatedRoute) {}

  ngOnInit() {
    const rest = this.route.snapshot.paramMap.get('rest') ?? '';
    this.router.navigateByUrl(`/viaggi-di-gruppo/${rest}`, {
      replaceUrl: true,
    });
  }
}
